import React from 'react';
import { createHook, createComponent } from 'reakit-system';

import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  ColorProps,
  compose,
  flexbox,
  FlexboxProps,
  grid,
  GridProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  shadow,
  ShadowProps,
  space,
  SpaceProps,
} from 'styled-system';
import { cx, css } from '@emotion/css';
import { Theme } from '@mos-cat/ds-theme';
import { useTheme } from '../hooks/useTheme';
import { StylesOptions, useStyles } from '../hooks/useStyles';


const boxScales = compose(
  border,
  position,
  space,
  border,
  layout,
  color,
  flexbox,
  grid,
  background,
  shadow
);

export type BoxOptions = BackgroundProps<Theme> &
  BorderProps<Theme> &
  ColorProps<Theme> &
  FlexboxProps<Theme> &
  GridProps<Theme> &
  LayoutProps<Theme> &
  PositionProps<Theme> &
  ShadowProps<Theme> &
  SpaceProps<Theme> &
  StylesOptions;

export type BoxHTMLProps = Omit<
  React.HTMLAttributes<any> & React.RefAttributes<any>,
  keyof BoxOptions
>;

export type BoxProps = BoxOptions & BoxHTMLProps;

const useBox = createHook<BoxOptions, BoxHTMLProps>({
  name: 'Box',
  keys: boxScales.propNames,
  compose: [useTheme, useStyles],
  useProps(options, props) {
    return {
      ...props,
      // @ts-expect-error
      className: cx(props.className, css({ label: 'Box' }, boxScales(options))),
    };
  },
});

const Box = createComponent({
  useHook: useBox,
  as: 'div',
  memo: true,
});

export { Box, useBox };
